<template>
  <div class="calico-tracker-table-header">
    <span class="label--xsmall">Tier / Business</span>

    <div 
      v-if="!hideExpiration"
      class="column-sort label--xsmall" 
      @click="$emit('toggle-sort')"
    >
      Expiration
      <i :class="sortIcon" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CalicoTrackerTableHeader',
  props: {
    sortAscending: { type: Boolean, default: true },
    hideExpiration: { type: Boolean, default: false }
  },
  computed: {
    sortIcon() {
      return this.sortAscending
        ? 'bi bi-caret-up-fill'
        : 'bi bi-caret-down-fill'
    }
  }
};
</script>

<style scoped lang="scss">
.calico-tracker-table-header {
  @include inline-space($space-medium);
  border-bottom: 1px solid $color-black;
  font-size: 14px;
  justify-content: space-between;
  padding: $space-large $space-none $space-small;

  .column-sort {
    background: transparent;
    border: none;
    cursor: pointer;
  }
}
</style>
